export const HTTP_STATUS_TOO_MANY_REQUESTS = 429;
export const HTTP_STATUS_TOO_MANY_REQUESTS = 429;
